/**
* @author vishwadeep.kapoor
* ReactTableWrapper
*
*/

import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import Pagination from '../Pagination';

function ReactTableWrapper(props) {
  const { data, columns, defaultPageSize, showPageJump, resizable, sortable, onPageChange, onPageSizeChange, showPagination, pageSize, noDataText } = props;
  return (
    <ReactTable
      {...props}
      data={data}
      columns={columns}
      showPageJump={showPageJump}
      resizable={resizable}
      sortable={sortable}
      defaultPageSize={defaultPageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      showPagination={showPagination}
      pageSize={pageSize} /** @const {3} for the case of no data */
      noDataText={noDataText}
      minRows={2}
      PaginationComponent={Pagination}
    />
  );
}

ReactTableWrapper.propTypes = {
  ...ReactTable.prototype,
  defaultPageSize: PropTypes.number,
  data: PropTypes.array,
  columns: PropTypes.array,
  showPageJump: PropTypes.bool,
  resizable: PropTypes.bool,
  sortable: PropTypes.bool,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  showPagination: PropTypes.bool,
  pageSize: PropTypes.number,
  noDataText: PropTypes.string,
};

ReactTableWrapper.defaultProps = {
  defaultPageSize: 10,
  showPageJump: true,
  resizable: true,
  sortable: false,
  showPagination: true,
  onPageChange: () => '',
  onPageSizeChange: () => '',
  pageSize: 5,
  noDataText: 'No data available',
};

export default ReactTableWrapper;



// WEBPACK FOOTER //
// client/components/ReactTableWrapper/index.js